import {
    SELECT_QUIZ,
    QUIZ_CREATE_REQUEST,
    QUIZ_CREATE_REQUEST_SUCCESS, 
    QUIZ_CREATE_REQUEST_FAIL,
    QUIZ_UPDATE_REQUEST, 
    QUIZ_UPDATE_REQUEST_SUCCESS, 
    QUIZ_UPDATE_REQUEST_FAIL,
    QUIZ_FIND_REQUEST, 
    QUIZ_FIND_REQUEST_SUCCESS,
    QUIZ_FIND_REQUEST_FAIL,
    QUIZ_DELETE_REQUEST,
    QUIZ_DELETE_REQUEST_SUCCESS, 
    QUIZ_DELETE_REQUEST_FAIL, 
  } from '../action.types';
  import initialValue from '../initial.state';
  
  export default function(state = initialValue.quiz, action) {
    switch (action.type) {
      case SELECT_QUIZ:
        return { ...action.quiz };
      case QUIZ_CREATE_REQUEST:
        return state;
      case QUIZ_CREATE_REQUEST_SUCCESS:
        return state;
      case QUIZ_CREATE_REQUEST_FAIL:
        return state;
      case QUIZ_UPDATE_REQUEST:
        return state;
      case QUIZ_UPDATE_REQUEST_SUCCESS:
        return state;
      case QUIZ_UPDATE_REQUEST_FAIL:
        return state;
      case QUIZ_FIND_REQUEST:
        return state;
        case QUIZ_FIND_REQUEST_SUCCESS:
        return { ...action.payload };
        case QUIZ_FIND_REQUEST_FAIL:
        return state;
        case QUIZ_DELETE_REQUEST:
        return state;
        case QUIZ_DELETE_REQUEST_SUCCESS:
        return state;
        case QUIZ_DELETE_REQUEST_FAIL:
        return state;
      default:
        return state;
    }
  }
  


// WEBPACK FOOTER //
// ./src/redux/quiz/quiz.reducer.js